var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconEye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 3C4.36364 3 1.25818 5.28067 0 8.5C1.25818 11.7193 4.36364 14 8 14C11.6364 14 14.7418 11.7193 16 8.5C14.7418 5.28067 11.6364 3 8 3ZM8 12.1667C5.99273 12.1667 4.36364 10.524 4.36364 8.5C4.36364 6.476 5.99273 4.83333 8 4.83333C10.0073 4.83333 11.6364 6.476 11.6364 8.5C11.6364 10.524 10.0073 12.1667 8 12.1667ZM8 6.3C6.79273 6.3 5.81818 7.28267 5.81818 8.5C5.81818 9.71733 6.79273 10.7 8 10.7C9.20727 10.7 10.1818 9.71733 10.1818 8.5C10.1818 7.28267 9.20727 6.3 8 6.3Z",
    fill: "#ACACAF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/IconEye.61e8fa556b30abc7961a85eb3b9edf23.svg";
export { ForwardRef as ReactComponent };